import React, { Suspense, useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import LoginScreen from "./Screens/Others/LoginScreen.js";
import RegisterScreen from "./Screens/Others/RegisterScreen.js";
import HomeScreen from "./Screens/Others/HomeScreen.js";
import ProtectedRoute from "./Utils/ProtectedRoute";
import AdminRoute from "./Utils/AdminRoute";
import Footer from "./components/Footer";
import ResetPassword from "./Screens/Others/ResetPassword.js";
import { Store } from "./Store.js";
import AdminScreen from "./Screens/Admin/AdminScreen.js";

function App() {
  const { dispatch } = useContext(Store);

  useEffect(() => {
    if (window.location.hash === "#signout") {
      dispatch({ type: "USER_SIGNOUT" });
    }
  }, [dispatch]);
  
  // auto logout after 23hours
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      const loginTime = new Date(userInfo.loginTime);
      const currentTime = new Date();
      const timeDifference = currentTime - loginTime;
      const hoursDifference = timeDifference / (1000 * 60 * 60);

      if (hoursDifference >= 23) {
        dispatch({ type: "USER_SIGNOUT" });
        localStorage.removeItem("userInfo");
        window.location.href = "/";
      }
    }
  }, [dispatch]);
  // useEffect(() => {
  //   let redirected = false;

  //   const handleOffline = () => {
  //     if (!redirected) {
  //       localStorage.removeItem("userInfo");
  //       localStorage.removeItem("cartItems");
  //       localStorage.removeItem("CurrUser");
  //       localStorage.removeItem("orderHistory");
  //       window.location.href = "/";
  //       redirected = true;
  //     }
  //   };

  //   window.addEventListener('offline', handleOffline);

  //   return () => {
  //     window.removeEventListener('offline', handleOffline);
  //   };
  // }, []);

  return (
    <>
      <div className="wrapper">
        <main
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <div style={{ flex: 1 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<LoginScreen />} />
                <Route path="/register" element={<RegisterScreen />} />
                <Route
                  path="/reset-password/:token"
                  element={<ResetPassword />}
                />
                <Route path="/home/*" element={<><ProtectedRoute><HomeScreen /> </ProtectedRoute></>} />
                {/* <Route path="/home/*" element={<HomeScreen />} /> */}
                <Route path="/admin/*" element={<><AdminRoute><AdminScreen /></AdminRoute></>} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </main>
      </div>
    </>
  );
}

export default App;
